import { createSlice } from '@reduxjs/toolkit';
import { updateLocalStorageToken, logOut } from "../../../../../../containers/resources/utils";
import axios from 'axios';

export const avalabilitySlice = createSlice({
  name: 'avalability',
  initialState: {
    items: [],
    processing: false,
    fetching: false,
    message: "",
    error: "",
  },
  reducers: {
    initialStateAvailability(state, action) {
      return {
        items: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    requesAvailability(state, action) {
      return {
        items: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      }
    },
    fetchAvailabilitySuccess(state, action) {
      return {
        items: action.payload,
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    fetchAvailabilityError(state, action) {
      return {
        items: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.payload.message,
      }
    }
  }
})

export const fetchAvailability = (yachtId, startDate, endDate) => dispatch => {
  dispatch(requesAvailability());
  var url = `availability?yacht_id=${yachtId}&&startDate=${startDate}&&endDate=${endDate}`;
  axios.get(`/${url}`)
    .then(json => {
      if (json.data.code === 200) {
        dispatch(fetchAvailabilitySuccess(json.data.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchAvailability(yachtId, startDate, endDate));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchAvailabilityError(json.data.data));
      }
    })
};

export const {
  initialStateAvailability,
  requesAvailability,
  fetchAvailabilitySuccess,
  fetchAvailabilityError,
} = avalabilitySlice.actions;

export default avalabilitySlice.reducer;